import {ChangeDetectorRef, Component, ElementRef, ViewChild} from '@angular/core';
import {AlertController, IonContent, Platform} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';
import { zip} from 'rxjs';
import {finalize} from 'rxjs/operators';

import 'cordova-plugin-purchase';

import {UserContent, UserProfile} from 'app/profile/model/model';
import {UserService} from 'app/profile/services/user.service';
import {getTranslation} from 'shared/helpers/get-translation';
import {NavService} from 'shared/nav/nav.service';
import {ContentService} from '../../services/content.service';

import { DefaultPage } from 'app/menu/components/default-page/default-page';
import { Dialog, DialogsService } from 'app/dialogs';
import { LocalisedText } from 'app/search';

const LABEL_FORMAT: string = 'dddd, DD.MM.YYYY';
const ABO_ID: string = 'powerimpulse_plus';

@Component({
  selector: 'content-page',
  templateUrl: 'content-page.html',
  styleUrls: ['content-page.scss'],
})
export class ContentPage extends DefaultPage {

  public isLoading: boolean = false;
  public userContents: Array<UserContent> = [];
  public keywords: Array<string> = [];

  public products: Array<CdvPurchase.Product> = []; /* [{id: 'prod1', description: 'describe', title: 'TIle', price: '7,00', currency: 'EUR', state: 'ok',
                                                   type: 'nc', priceMicros: 3, loaded: true, valid: true, canPurchase: true, owned: false, finish: null,
                                                  verify: null, set: null, stateChanged: null, on: null, off: null, trigger: null, once: null }];*/
  private startUserContentId: string;

  private inCharge: boolean = false;

  public isLeader: boolean = true;

  public showLeaderContent: boolean = false; // show leader content despite you are no leader
  private selUserContent: UserContent = null;
  private selContentTitle: string;
  private selOffset: number = 0;
  
  public isShowSuggestRaw: boolean = false;

  public catSelect: string = 'all';
  public selectedKeyword: string = '';
  public userContentsForKeyword: Dictionary<Array<UserContent>> =  {};

  public filterText = '';
  public hasContentsUnfiltered = false;
  public hasContentsActiveUnfiltered = false;

  public userContentExpanded: Dictionary<boolean> = {};

  // 0 .. nothing
  // 1 .. is Powerimpulse- User (could buy)
  // 2 .. in store available
  // 3 .. just buying
  // 4 .. bought
  public leadaAboState = 0;

  public abo: CdvPurchase.Product;

  @ViewChild(IonContent, { static: false }) private pageContent: IonContent;

  public warnEn: number = 0;

  private store?: CdvPurchase.Store;

  private cdvPlatform: CdvPurchase.Platform;

  constructor(
    private navService: NavService,
    private translateService: TranslateService,
    private contentService: ContentService,
    private userService: UserService,
    private alertCtrl: AlertController,
    private platform: Platform,
    private ref: ChangeDetectorRef,
    private dialogsService: DialogsService,
  ) {
    super(navService);
    this.selUserContent = <UserContent> this.navService.get('selUserContent'); // from jump from dashboard
    this.selContentTitle = this.navService.get('selContentTitle');
    this.platform.ready().then(() => {
      if (this.platform.is('capacitor')) {
        this.log('in capacitor');

        this.store = CdvPurchase.store;
        this.cdvPlatform = this.platform.is('ios') ? CdvPurchase.Platform.APPLE_APPSTORE : CdvPurchase.Platform.GOOGLE_PLAY;
        this.store.verbosity = CdvPurchase.LogLevel.DEBUG;

        this.store.when(/*'product'*/)
        .approved((p: CdvPurchase.Transaction) => {
          if (!this.inCharge) {
            return;
          }
          if (p.purchaseId === 'de.leada.app') { // ios
            return;
          }
          // Handle the product deliverable
          this.log('approved: ' + JSON.stringify(p));
          if ( p.products[0]?.id == ABO_ID ) {
            return this.contentService.purchaseAbo(ABO_ID)
              .subscribe((ok) => {
                if (ok) {
                  this.log('call verify: ' + ABO_ID);
                  return p.verify();
                } else {
                  this.showErrorAlert('[_1]');
                  return;
                }
              });
          }
/*          const userContent: UserContent = this.userContents.find(uc => uc.contentFull.productId == p.purchaseId);
          if (userContent !== undefined) {
            this.log('call server.purchase: ' + p.purchaseId);
            return this.contentService.purchase(userContent, p.purchaseId)
              .subscribe((ok) => {
                if (ok) {
                  this.log('call verify: ' + p.purchaseId);
                  return p.verify();
                } else {
                  this.showErrorAlert('[_1]');
                  return;
                }
              });
          } else {
            this.showErrorAlert('[2]');
          }*/
          p.verify();
        })
        .verified((p: CdvPurchase.VerifiedReceipt) => {
          if (!this.inCharge) {
            return;
          }
          if ( p.id === 'de.leada.app') { // ios
            return;
          }
          this.log('verified: ' + JSON.stringify(p));
          const prodId = p.sourceReceipt?.transactions[0]?.products[0]?.id;
          const userContent: UserContent = this.userContents.find(uc => uc.contentFull.productId == prodId);
          if (userContent !== undefined || prodId == ABO_ID) {
            this.log('call finish: ' + p.id);
            p.finish();
          }
          if (prodId == ABO_ID ) {
            if (this.leadaAboState == 3) {
              this.log("ABO just buying");
              this.leadaAboState = 4;
              this.showPurchasedAlert();
            }
            else {
              this.log("ABO already bought");
              this.leadaAboState = 4;
            }
          }
        })
        // .owned((p: IAPProduct) => {
        //   this.log('owned: ' + p.id);
        // })
        // .registered((p: CdvPurchase.Transaction) => {
        //   this.log('registered ' + p.id + ' ' + p.price);
        // })
        // .loaded((p: IAPProduct) => {
        //   this.log('loaded  ' + p.id + ' ' + p.price);
        //   this.products = [...this.store.products];
        // });
        .initiated((p: CdvPurchase.Transaction) => {
          this.log('loaded  ' + p.purchaseId + ' ' + p.products);
          this.products = [...this.store.products];
        })
        .productUpdated((p: CdvPurchase.Product) => {
          this.log('productUpdated  ' + p.id + ' ' + p.pricing);
        })
        .receiptUpdated((r: CdvPurchase.Receipt) => {
          this.log('receiptUpdated  ' + r);
        })
        .finished((p: CdvPurchase.Transaction) => {
          this.log('finished  ' + p.purchaseId + ' ' + p.products);
        });
        this.log('store callbacks registered');

        this.store.ready(() => {
          this.store.products.forEach(p => {
            this.log('store ready ' + p.id + ' ' + JSON.stringify(p));
            if (this.leadaAboState == 1 && p.id == ABO_ID) {
              this.leadaAboState = 2;
              this.log('store ready ABO read');
              this.abo = p;
            }
          });
          this.products = [...this.store.products];
          this.updateKeywords();
          this.ref.detectChanges();
          this.log('store ready #Prod: '+ this.products.length);
        });

        // this.log("do initialize")
        // this.store.initialize([CdvPurchase.Platform.GOOGLE_PLAY]);
      }
    });
    if ( userService.getAdminMode() ) {
      this.isShowSuggestRaw = true;
    }
    this.leadaAboState = userService.getCompanyCached() == 'Powerimpulse' ? 1 : 0;
  }

  public get hasContents(): boolean {
    return this.userContentsToDisplay.length > 0;
  }

  public get userContentsToDisplay(): Array<UserContent> {
    const unfiltered = this.userContents
      .filter(userContent => userContent.state != 3 || this.getPrice(userContent, this.products) != '-')
      .filter(userContent => userContent.state >= 5
        || !userContent.contentFull
        || !userContent.contentFull.leadersOnly
        || (this.isLeader || this.showLeaderContent));
    this.hasContentsUnfiltered = unfiltered.length > 0;    
    return unfiltered
      .filter(userContent => this.filterText === '' || this.matchesFilter(userContent));
  }

  private matchesFilter(userContent: UserContent): boolean {
    if (!userContent.contentFull) {
      return false;
    }
    return this.matchesFilterText(userContent.contentFull.title) || this.matchesFilterText(userContent.contentFull.description) || this.matchesFilterText(userContent.contentFull.keywords);
  }

  private matchesFilterText(locText: LocalisedText): boolean {
    if ( !locText ) {
      return false;
    }
    if ( locText['de'] && locText['de'].toLowerCase().indexOf(this.filterText) != -1) {
      return true;
    }
    if ( locText['en'] && locText['en'].toLowerCase().indexOf(this.filterText) != -1) {
      return true;
    }
    return false;
  }

  public get userContentsActive(): Array<UserContent> {
    const unfiltered = this.userContents
      .filter(userContent => userContent.state >= 5);
    this.hasContentsActiveUnfiltered = unfiltered.length > 0;
    return unfiltered  
      .filter(userContent => this.filterText === '' || this.matchesFilter(userContent));
  }

  private ionViewWillEnter(): void {
    this.log("wil enter");
    this.isLoading = true;
    this.load();
    this.inCharge = true;
  }

  private ionViewDidEnter(): void {
    setTimeout(() => {
      this.scrollToSel();
    });
  }

  private scrollToSel():void {
    if ( this.selUserContent !== undefined && this.selUserContent !== null ) {
      if (this.userContentsToDisplay.length > 0) {
        const s = getTranslation(this.selUserContent.contentFull.keywords, this.translateService);
        const b = s.split(';');
        const keyword = b[0].trim();
        if ( this.userContentsForKeyword[keyword] !== undefined ) {
          this.selectedKeyword = keyword;
          this.userContentExpanded[this.selUserContent._id] = true;
          setTimeout(() => {
            const selContentEle = document.getElementById(this.selUserContent._id+'_title');
            if (selContentEle == null) { // ios
              setTimeout(() => {
                this.scrollToSel()
              }, 500);
              return;
            }
            if (this.selOffset != selContentEle.offsetTop) {
              this.selOffset = selContentEle.offsetTop
              this.pageContent.scrollToPoint(0, this.selOffset, 1000);
              setTimeout(() => {
                this.scrollToSel()
              }, 500);
            }
            else {
              this.selUserContent = null; // done
            }
          });
            }
      }
      else {
        setTimeout(() => {
          this.scrollToSel()
        }, 500);
      }
/*
      console.log("sel : %o", this.selUserContent);
      setTimeout(() => {
        const selContentEle = document.getElementById(this.selUserContent._id);
        if (selContentEle == null) { // ios
          setTimeout(() => {
            this.scrollToSel()
          }, 500);
          return;
        }
        if (this.selOffset != selContentEle.offsetTop) {
          this.selOffset = selContentEle.offsetTop
          this.pageContent.scrollToPoint(0, this.selOffset, 1000);
          setTimeout(() => {
            this.scrollToSel()
          }, 500);
        }
      });*/
    }
  }
  private ionViewWillLeave(): void {
    // reset all "new" marks
    const userContentIds: Array<string> = this.userContents
      .filter((userContent) => userContent.new).map((userContent) => userContent._id);
    if (userContentIds.length > 0) {
      this.userService.markContentsDisplayed(userContentIds).subscribe();
    }
    this.inCharge = false;
  }

  private load(userContentStartedId?: string): void {
/*    this.selOffset = 0;
    this.selectedKeyword = '';
    this.userContentExpanded = {};
    this.userContents = [];*/
    this.contentService.getContents('list')
      .pipe(finalize(() => { this.isLoading = false; }))
      .subscribe((userContents: Array<UserContent>) => {
        this.userContents = userContents;
        this.log('USERCONTENT LOADED');
        this.updateKeywords();
        if (this.keywords.length > 0 && this.selectedKeyword == '' && (this.selUserContent === undefined || this.selUserContent == null) ) {
          setTimeout(() => { this.selectKeyword(this.keywords[0]); }, 1000);
        } 
        this.userService.setNewContentCount(0);
        if (this.selUserContent !== undefined && this.selUserContent !== null) {
          // load complete data
          this.userContents.forEach((a: UserContent) => {
            if (a._id == this.selUserContent._id) {
              this.selUserContent = a;
            }
          });
        }
        if (this.selContentTitle !== null) {
          this.userContents.forEach((a: UserContent) => {
            if (a.contentFull.title &&
              ((a.contentFull.title.de && a.contentFull.title.de == this.selContentTitle)
                || (a.contentFull.title.de && a.contentFull.title.de == this.selContentTitle))) {
              this.selUserContent = a;
            }
          });
        }
        if (userContentStartedId) {
          const startedContent: UserContent = userContents.find((content) => content._id == userContentStartedId);
          if (startedContent) {
            const firstImpulseDate: moment.Moment = this.getFirstImpulseDate(startedContent);
            if (firstImpulseDate.isAfter(moment(), 'days')) {
              this.showFirstImpulseInfo(firstImpulseDate.toDate());
            }
          }
        } else {
          // register products
          if (this.platform.is('capacitor')) {
            let didRegister = false;
            this.userContents.forEach((userContent) => {
              if ((userContent.state == 3 || (userContent.purchasedAt !== undefined && userContent.purchasedAt !== null)) && userContent.contentFull.productId !== undefined) {
                const alreadyRegistered = this.store.products.find((prod) => { return prod.id == userContent.contentFull.productId; });
                if (alreadyRegistered === undefined && userContent.contentFull.productId != '') {
                  this.log('register "' + userContent.contentFull.productId+'"');
                  this.store.register({
                    id: userContent.contentFull.productId,
                    type: CdvPurchase.ProductType.NON_CONSUMABLE,
                    platform: this.cdvPlatform,
                    group: 'default',
                  });
                  didRegister = true;
                }
              }
            });
            if (this.leadaAboState == 1) {
              this.log('register ABO ' + ABO_ID);
              this.store.register({
                id: ABO_ID,
                type: CdvPurchase.ProductType.PAID_SUBSCRIPTION,
                platform: this.cdvPlatform
              });
              didRegister = true;
            }
            if (didRegister) {
              this.log("do initialize");
              setTimeout(() => {this.store.initialize([this.cdvPlatform]);}); // war update
            }
          }
        }
        // start purchased content
        if (this.startUserContentId !== undefined) {
          const ucToStart = this.userContents.find(uc => (uc._id + '') == this.startUserContentId);
          this.startUserContentId = undefined;
          if (ucToStart !== undefined) {
            this.start(ucToStart, undefined);
          }
        }
        // scroll
        setTimeout(() => {
          this.scrollToSel();
        });
    });
    this.userService.getUserProfile('settings')
      .subscribe((profile: UserProfile) => {
        if (profile.settings && profile.settings.leading) {
            this.isLeader = profile.settings.leading.leading;
            this.showLeaderContent = profile.settings.showLeaderContent;
        }
      });
  }

  public selectKeyword(keyword: string): void {
    if (this.selectedKeyword == keyword) {
      this.selectedKeyword = '';
    }
    else {
      this.selectedKeyword = keyword;
    }
  }

  private updateKeywords(): void {
    const keywordsSet: Set<string> = new Set();
    this.userContentsForKeyword = {};
    const userContentsForKeywordTemp: Dictionary<Array<UserContent>> = {};
    this.userContentsToDisplay.forEach((a: UserContent) => {
      if (a.contentFull.keywords) {
        const s = getTranslation(a.contentFull.keywords, this.translateService);
        const b = s.split(';');
        const keyword = b[0].trim();
        keywordsSet.add(keyword); // only the first keyword
        if (userContentsForKeywordTemp[keyword] === undefined) {
          userContentsForKeywordTemp[keyword] = [];
        }
        userContentsForKeywordTemp[keyword].push(a);
      }
    });
    keywordsSet.forEach(keyword => {
      this.userContentsForKeyword[keyword] = userContentsForKeywordTemp[keyword]
        .sort((a, b) => {
          const sa = a.contentFull.title !== undefined && a.contentFull.title[this.translateService.currentLang] !== undefined ? 
            a.contentFull.title[this.translateService.currentLang] : '';
          const sb = b.contentFull.title !== undefined && b.contentFull.title[this.translateService.currentLang] !== undefined ? 
            b.contentFull.title[this.translateService.currentLang] : '';
          return sa.localeCompare(sb);
        });
    });
    this.keywords = Array.from(keywordsSet.values()).sort();
    if (this.selectedKeyword !== '' && !this.keywords.includes(this.selectedKeyword)) {
      this.selectedKeyword = '';
    }

    // userContentExpanded evtl. bereinigen
    const usedUserContIds = this.userContentsToDisplay.map(userContent => userContent._id);
    for (let id in this.userContentExpanded) {
      if ( !usedUserContIds.includes(id) && this.userContentExpanded[id]) {
        this.userContentExpanded[id] = false;
      }
    }
  }

  public trackKeywords(index: number, keyword: string): string {
    return keyword;
  }

  public hasNew(keyword: string): boolean {
    return this.userContentsForKeyword[keyword] !== undefined 
      && this.userContentsForKeyword[keyword]
          .find(uc => uc.new) != undefined;
  }


  public trackUserContent(index: number, userContent: UserContent): string {
    return userContent._id;
  }

  public getLocalizedContentText(text: Dictionary<string>): string {
    const res = getTranslation(text, this.translateService);
    if (res == '' && this.translateService.currentLang != 'de') {
      if ( this.warnEn == 0 ) {
        setTimeout(() => {
          if ( this.warnEn == 0 ) {
            this.warnEn = 1;
            setTimeout(() => {this.warnEn = 2;}, 3000);
          }; }, 1000);
      }
    }
    return getTranslation(text, this.translateService);
  }

  public getContentClass(userContent: UserContent): string {
    return 'item-level-3 state content-body ' + userContent.state + (this.selUserContent != null && this.selUserContent._id == userContent._id ? ' selected' : '') + (userContent.suggest != undefined && userContent.suggest > 0 ? ' suggested' : '');
  }

  public isNew(userContent: UserContent): boolean {
    return userContent.new;
  }

  public formateDate(date: Date): string {
    return moment(date).format('DD.MM.YYYY');
  }

  public getPrice(userContent: UserContent, products: Array<CdvPurchase.Product>): string {
    const product = products.find(p => p.id == userContent.contentFull.productId);
    return this.getProductPrice(product);
  }

  public getProductPrice(product: CdvPurchase.Product): string {
    return product !== undefined && product.pricing !== null ? product.pricing.price + ' ' + product.pricing.currency : '-';
  }

  public start(userContent: UserContent, event: Event): void {
    if ( event !== undefined ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    // const hasRunningContent: boolean = this.userContents.find((uc) => { return uc.state === 5; }) !== undefined;
    // if (hasRunningContent) {
    //   this.showStartAlert(userContent);
    // } else {
    //   this.doStart(userContent);
    // }
   this.showStartAlert(userContent);
  }

  private doStart(userContent: UserContent, runNow: boolean): void {

    this.contentService.start(userContent)
      .subscribe(() => {
        // recalc
        this.contentService.calculateNewContents()
          .subscribe((cnt) => {
            this.userService.setNewContentCount(cnt);
            this.load(userContent._id);
          });
        // display
        if ( runNow ) {
          this.contentService.getContent(userContent)
          .subscribe((userContent2) => {
            this.showContent(userContent2);
          });
        }
      });
  }

  public pause(userContent: UserContent, event: Event): void {
    if ( event !== undefined ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    this.contentService.pause(userContent)
      .subscribe(() => {
        // hier reicht ein load
        this.load();
      });
  }

  public resume(userContent: UserContent, event: Event): void {
    if ( event !== undefined ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    this.contentService.resume(userContent)
      .subscribe(() => {
        // hier reicht ein load
        this.load();
      });
  }

  public restart(userContent: UserContent, event: Event): void {
    if ( event !== undefined ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    this.showRestartAlert(userContent);
  }

  private doRestart(userContent: UserContent, runNow: boolean): void {
    this.contentService.restart(userContent)
      .subscribe(() => {
        // recalc
        this.contentService.calculateNewContents()
          .subscribe((cnt) => {
            this.userService.setNewContentCount(cnt);
            this.load(userContent._id);
          });
        // display
        if ( runNow ) {
          this.contentService.getContent(userContent)
          .subscribe((userContent2) => {
            this.showContent(userContent2);
          });
        }
      });
  }

  public purchase(userContent: UserContent, event: Event): void {
    if ( event !== undefined ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    const product = this.products.find(p => p.id == userContent.contentFull.productId);
    if (product !== undefined) {
      this.navService.push('content/purchase', {product: product, userContent: userContent});
    }
  }

  public getPdf(userContent: UserContent, event: Event): void {
    if ( event !== undefined ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    this.contentService.getPdf(userContent._id, this.getLocalizedContentText(userContent.contentFull.title))
    .then((info) => {
      console.log(info);
    });
  }

  private getFirstImpulseDate(userContent: UserContent): moment.Moment {
    let minDay: number = 999;
    userContent.contentFull.items.forEach((item) => {
      if (item.day < minDay) {
        minDay = item.day;
      }
    });
    return moment(userContent.baseDate).add(minDay, 'days');
  }

  private showStartAlert(userContent: UserContent): void {

    this.translateService.get([
      'CONTENT.START_ALERT.TITLE',
      'CONTENT.START_ALERT.MESSAGE',
      'CONTENT.START_ALERT.BUTTON_STAY',
      'CONTENT.START_ALERT.BUTTON_GO',
    ]).subscribe(async(translations) => {
      const titleLabel: string = translations['CONTENT.START_ALERT.TITLE'];
      const message: string = translations['CONTENT.START_ALERT.MESSAGE'];
      const stayLabel: string = translations['CONTENT.START_ALERT.BUTTON_STAY'];
      const goLabel: string = translations['CONTENT.START_ALERT.BUTTON_GO'];

      const alert: HTMLIonAlertElement = await this.alertCtrl.create({
        cssClass: 'start-content-alert-class',
        header: titleLabel,
        message: message,
        buttons: [
          {
            text: stayLabel,
            handler: (): void => {
              this.doStart(userContent, false);
            },
          },
          {
            text: goLabel,
            handler: (): void => {
              this.doStart(userContent, true);
            },
          },
        ],
      });
      alert.present();
    });
  }

  // private showStartAlert(userContent: UserContent): void {

  //   this.translateService.get([
  //     'CONTENT.START_ALERT.TITLE',
  //     'CONTENT.START_ALERT.MESSAGE',
  //     'COMMON.NO',
  //     'COMMON.YES',
  //   ]).subscribe(async(translations) => {
  //     const titleLabel: string = translations['CONTENT.START_ALERT.TITLE'];
  //     const message: string = translations['CONTENT.START_ALERT.MESSAGE'];
  //     const noLabel: string = translations['COMMON.NO'];
  //     const yesLabel: string = translations['COMMON.YES'];

  //     const alert: HTMLIonAlertElement = await this.alertCtrl.create({
  //       cssClass: 'start-content-alert-class',
  //       header: titleLabel,
  //       message: message,
  //       buttons: [
  //         {
  //           text: noLabel,
  //           role: 'cancel',
  //         },
  //         {
  //           text: yesLabel,
  //           handler: (): void => {
  //             this.doStart(userContent);
  //           },
  //         },
  //       ],
  //     });
  //     alert.present();
  //   });
  // }

  private showRestartAlert(userContent: UserContent): void {

    this.translateService.get([
      'CONTENT.RESTART_ALERT.TITLE',
      'CONTENT.RESTART_ALERT.MESSAGE',
      'COMMON.NO',
      'CONTENT.RESTART_ALERT.BUTTON_STAY',
      'CONTENT.RESTART_ALERT.BUTTON_GO',
    ]).subscribe(async(translations) => {
      const titleLabel: string = translations['CONTENT.RESTART_ALERT.TITLE'];
      const message: string = translations['CONTENT.RESTART_ALERT.MESSAGE'];
      const noLabel: string = translations['COMMON.NO'];
      const stayLabel: string = translations['CONTENT.RESTART_ALERT.BUTTON_STAY'];
      const goLabel: string = translations['CONTENT.RESTART_ALERT.BUTTON_GO'];

      const alert: HTMLIonAlertElement = await this.alertCtrl.create({
        cssClass: 'start-content-alert-class',
        header: titleLabel,
        message: message,
        buttons: [
          {
            text: noLabel,
            role: 'cancel',
          },
          {
            text: stayLabel,
            handler: (): void => {
              this.doRestart(userContent, false);
            },
          },
          {
            text: goLabel,
            handler: (): void => {
              this.doRestart(userContent, true);
            },
          },
        ],
      });
      alert.present();
    });
  }

  // private showRestartAlert(userContent: UserContent): void {

  //   this.translateService.get([
  //     'CONTENT.RESTART_ALERT.TITLE',
  //     'CONTENT.RESTART_ALERT.MESSAGE',
  //     'COMMON.NO',
  //     'COMMON.YES',
  //   ]).subscribe(async(translations) => {
  //     const titleLabel: string = translations['CONTENT.RESTART_ALERT.TITLE'];
  //     const message: string = translations['CONTENT.RESTART_ALERT.MESSAGE'];
  //     const noLabel: string = translations['COMMON.NO'];
  //     const yesLabel: string = translations['COMMON.YES'];

  //     const alert: HTMLIonAlertElement = await this.alertCtrl.create({
  //       cssClass: 'start-content-alert-class',
  //       header: titleLabel,
  //       message: message,
  //       buttons: [
  //         {
  //           text: noLabel,
  //           role: 'cancel',
  //         },
  //         {
  //           text: yesLabel,
  //           handler: (): void => { console.log("EXEC");
  //             this.doRestart(userContent);
  //           },
  //         },
  //       ],
  //     });
  //     alert.present();
  //   });
  // }
  private showFirstImpulseInfo(startdate: Date): void {

    this.translateService.get([
      'CONTENT.FIRST_IMPULSE.TITLE',
      'CONTENT.FIRST_IMPULSE.MESSAGE',
      'COMMON.OK',
    ],
    {datum: this.formateDate(startdate)},
    ).subscribe(async(translations) => {
      const titleLabel: string = translations['CONTENT.FIRST_IMPULSE.TITLE'];
      const message: string = translations['CONTENT.FIRST_IMPULSE.MESSAGE'];
      const okLabel: string = translations['COMMON.OK'];

      const alert: HTMLIonAlertElement = await this.alertCtrl.create({
        cssClass: 'first-impulse-alert-class',
        header: titleLabel,
        message: message,
        buttons: [okLabel],
      });
      alert.present();
    });
  }

  private showErrorAlert(s: string): void {
    zip(
      this.translateService.get('COMMON.ERROR'),
      this.translateService.get('COMMON.OK'),
      this.translateService.get('CONTENT.COULD_NOT_PURCHASE'),
    ).subscribe(async(translations) => {
      const alert: HTMLIonAlertElement = await this.alertCtrl.create({
        subHeader: translations[0],
        buttons: [translations[1]],
        // tslint:disable-next-line:no-magic-numbers
        message: translations[2] + ' ' + s,
      });
      alert.present();
    });
  }

  public showContent(userContent: UserContent) {
    if (userContent.state >= 5) {
      if ( userContent.state == 9) {
        this.navService.push('content/flow', { userContent: userContent });
        return;
      }
      // load matching Dialog
      this.dialogsService.getDialogs()
      .subscribe((dialogs) => { 
        const cand: Array<Dialog> = [];
        for(let i = 0; i < dialogs.length; i++) {
          if ( dialogs[i].contentInfo !== undefined && dialogs[i].contentInfo.uc_id == userContent._id ) {
            cand.push(dialogs[i]);
          }
        }
        if ( cand.length > 0 ) {
          const dia = cand.reduce((acc: Dialog, cur:Dialog) => acc == null || acc.contentInfo.pos > cur.contentInfo.pos ? cur : acc, null);
          this.navService.push('content/flow', { dialog: dia });
        } else {
          // otherwise no active dialog, so just display
          this.navService.push('content/flow', { userContent: userContent });
        }
      });
    }
  }

  
  // purchase Abo

  public purchaseAbo(): void {
    console.log("YYY call order: "+this.abo.id);
    this.leadaAboState = 3;
    this.store.order(this.abo.getOffer()).then(p => {
      console.log("YYY order abo")
    }, e => {
      this.showErrorAlert(`YYY Failed to purchase: ${e}`);
    });
  }

  private showPurchasedAlert(): void {

    this.translateService.get([
      'CONTENT.ABO.PURCHASED_ALERT.TITLE',
      'CONTENT.ABO.PURCHASED_ALERT.MESSAGE',
      'COMMON.OK',
    ]).subscribe(async(translations) => {
      const titleLabel: string = translations['CONTENT.ABO.PURCHASED_ALERT.TITLE'];
      const message: string = translations['CONTENT.ABO.PURCHASED_ALERT.MESSAGE'];
      const okLabel: string = translations['COMMON.OK'];

      const alert: HTMLIonAlertElement = await this.alertCtrl.create({
        cssClass: 'first-impulse-alert-class',
        header: titleLabel,
        message: message,
        buttons: [
          {
            text: okLabel,
            handler: (): void => {
              this.load();
            },
          },
        ],
      });
      alert.present();
    });
  }

  private log(s: string): void {
    console.log('YYY ' + s);
  }

  handleFilterInput(event) {
    this.filterText = event.target.value.toLowerCase().trim();
    this.updateKeywords();
  }

}
